import React, { useEffect } from 'react';
import useToggle from '../../Hooks/useToggle';
import StickyMenu from '../../lib/StickyMenu';
import BackToTop from '../BackToTop';
import DownloadHomeTwo from '../HomeOneFacilities/DownloadHomeTwo';
import FooterHomeOne from '../HomeOneFacilities/FooterHomeOne';
import HomeOneHeader from '../HomeOneFacilities/HomeOneHeader';
import Drawer from '../Mobile/Drawer';
import DetailsService from './DetailsService';
import HeroService from './HeroService';

function Service() {
    useEffect(() => {
        StickyMenu();
    });
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HomeOneHeader action={drawerAction.toggle} />
            <HeroService />
            <DetailsService />
            <DownloadHomeTwo />
            <FooterHomeOne />
            <BackToTop />
        </>
    );
}

export default Service;
